export default class EditorService {
  static $inject = [];

  private _editors;
  private _waitingForFocus = new Set<string>();
  private sessions = new Map<string, AceAjax.IEditSession>();

  constructor() {
    this._editors = Object.create({});
  }

  registerSession(token: string, session: AceAjax.IEditSession) {
    this.sessions.set(token, session);
  }

  getSession(token: string) {
    return this.sessions.get(token);
  }

  remapSession(oldToken: string, newToken: string) {
    this.sessions.set(newToken, this.sessions.get(oldToken));
    this.sessions.delete(oldToken);
  }

  destroySession(token: string) {
    return this.sessions.delete(token);
  }

  registerEditor(editor: AceAjax.Editor, mode = 'sql') {
    this._editors[mode] = editor;
    if (this._waitingForFocus.has(mode)) {
      setTimeout(() => editor.focus(), 10);

      this._waitingForFocus.delete(mode);
    }
  }

  editorInstance(mode = 'sql'): AceAjax.Editor {
    return this._editors[mode];
  }

  /**
   * Support focusing on the editor even if it hasn't been mounted yet
   */
  setFocus(mode = 'sql') {
    if (this.editorInstance(mode) != null) {
      this.editorInstance(mode).focus();
    } else {
      this._waitingForFocus.add(mode);
    }
  }
}
